<template>
  <!--个人信息-->
  <div class="page-my-infomation">
    <div class="wrap">
      
      <div class="title">
        <span class="name">个人信息</span>
        <div class="btn-edit g-btn-level-1" v-show="pageType==='detail'" @click="pageType='edit'">修改信息</div>
      </div>
      <div class="per-line"></div>

      <div class="content">
        <!-- <img src="../../assets/image/person/img.png" alt=""> -->
        <img :src="form1.imageUrl||''" alt="" :onerror="defaultHeadImg" style="margin-bottom:20px;">
        <!-- <el-upload
          class="avatar-uploader"
          action=""
          :show-file-list="false"
          :before-upload="beforeAvatarUpload">
          <a href="javascript:void (0);" class="avatar-uploader-icon">修改头像</a>
        </el-upload> -->
        <el-form class="form" ref="form1" :model="form1" :rules="rules" label-width="80px">
          <!-- <el-form-item label="用户ID:" prop="idSelf">
            <el-input v-model="form1.idSelf" :disabled="true"></el-input>
          </el-form-item> -->
          <el-form-item label="昵称:" prop="userName">
            <span v-if="pageType==='detail'">{{form1.userName}}</span>
            <el-input v-model="form1.userName" disabled v-else></el-input>
          </el-form-item>

          <el-form-item label="性别:" prop="sex" style="text-align:left;">
            <span v-if="pageType==='detail'">{{detailData.sexStr}}</span>
            <el-radio-group v-model="form1.sex" v-else>
              <!-- <el-radio :label="''" style="margin-left:20px;">保密</el-radio> -->
              <el-radio :label="'0'" style="margin-left:20px;">男</el-radio>
              <el-radio :label="'1'">女</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="所在地区:">
            <span v-if="pageType==='detail'">{{detailData.provinceStr}}{{detailData.cityStr}}{{detailData.countyStr}}</span>
            <el-cascader v-else
              v-model="cityArr"
              clearable
              :options="cityList"
              change-on-select
              @change="handleChange"
              style="width: 100%;"
            ></el-cascader>
          </el-form-item>

          <el-form-item label="出生日期:" prop="birthday">
            <span v-if="pageType==='detail'">{{form1.birthday}}</span>
            <el-col v-else>
              <el-date-picker type="date" placeholder="选择日期"
              v-model="form1.birthday"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              style="width: 100%;">
              </el-date-picker>
            </el-col>
          </el-form-item>

          <el-form-item label="职业:" prop="unitName">
            <span v-if="pageType==='detail'">{{detailData.job}}</span>
            <el-input v-model="form1.job" v-else></el-input>
          </el-form-item>

          <el-form-item label="用户标签:" class="area" prop="tags">
            <span v-if="pageType==='detail'">{{detailData.userTags}}</span>
            <!-- <el-input type="textarea" v-model="form1.tags" :maxlength="20" v-else></el-input> -->
            <el-select v-model="value1" placeholder="请选择" style="width:100%;" v-else>
              <el-option
                v-for="item in tagList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div class="footer tc" v-show="pageType=='edit'">
          <el-button type="primary" @click="save">确 定</el-button>
          <el-button @click="cancel">取 消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import Cookies from 'js-cookie'
  export default {
    name: 'gerenxinxi',
    data() {
      return {
        pageType: 'edit', 
        // pageType: 'detail', 

        defaultHeadImg: this.$store.state.user.defaultHeadImg,
        imgId: '',
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
        form1: {
          // idSelf: this.$store.state.user.userid,
          userName: this.$store.state.user.userName,
          sex: '',
          birthday: '',
          job: '',
        },
        rules: {
          unitName: [
            { required: true, message: '请输入昵称', trigger: 'blur' },
          ],
          // singleName: [
          //   {  min: 10, message: '至少10个字', trigger: 'blur' },
          // ],
        },
        tagList: [],
        value1: [],
        cityArr: [],
        cityList: [],
        detailData: {}
      }
    },
    methods: {
      // 获取城市
      handleChange(value) {
        if(value.length == 2) {
          this.form1.provinceId = value[0]
          this.form1.cityId = value[1]
        }
      },
      // 上传头像
      beforeAvatarUpload(file) {
        let vm = this
        let fd = new FormData()
        fd.append('file', file)
        fd.append('projectName', 'post_pub_user')

        this.$http.post('/attach/Picture.do', fd)
        .then((res) => {
          if(res.data.success == 0) {
            // vm.$message.success('上传成功');
            vm.form1.imageUrl = res.data.data.errorPath
            vm.imgId = res.data.data.id
          } else {
            vm.$message.error(res.data.msg)
          }
        })
        return true
      },
      // 保存
      save() {
        this.$refs['form1'].validate((valid) => {
          if (valid) {
            this.$http.get('/user/updateUserInfo.do', {
              id: this.$store.state.user.userid,
              token: this.$store.state.user.token,
              ...this.form1,
              tags: this.value1,
              province: this.cityArr[0] || '',
              city: this.cityArr[1] || '',
              county: this.cityArr[2] || ''
            }).then((res) => {
              if(res.success === 1) {
               // res.data.data.other1 && Cookies.set('headImg', res.data.data.other1, { expires: 7 });
              //  res.data.data.other1 && (this.$store.state.user.headImg = res.data.data.other1)
                this.$message.success('保存成功')
                this.getUserInfo()
                this.pageType = 'detail'
              } else {
                this.$message.error(res.message)
              }
            })
          } else {
            return false
          }
        })
      },
      cancel() {
        this.pageType = 'detail'
      },
      // 获取城市信息
      getCityData() {
        this.$http.get('/user/getArea.do', {}).then((res) => {
          this.cityList = res.data
        })
      },
      // 获取用户信息
      getUserInfo() {
        this.$http.get('/user/getUserInfo.do', {
          userId: this.$store.state.user.userid,
          token: this.$store.state.user.token
        }).then((res) => {
          if(res.success === 1) {
            this.detailData = res.data.user
            this.tagList = res.data.tagsList
            console.log(this.tagList)
            let data = res.data.user
            this.value1 = data.tags
            // this.form1.sexStr = data.sexStr
            // this.form1.userTags = data.userTags
            this.form1.sex = data.sex
            this.form1.birthday = data.birthday
            this.form1.job = data.job
            if(data.county) {
              this.cityArr = [data.province, data.city, data.county]
            } else if(data.city) {
              this.cityArr = [data.province, data.city]
            } else if(data.province) {
              this.cityArr = [data.province]
            }
            // this.form1.tags = data.tags
            // let data = res.data.data
            // data.sex && (this.form1.sex = Number(data.sex))
            // data.birthdayStr && (this.form1.birthday = data.birthdayStr)
            // data.provinceId && (this.form1.provinceId = data.provinceId)
            // data.cityId && (this.form1.cityId = data.cityId)
            // data.job && (this.form1.job = data.job)
            // data.singleName && (this.form1.singleName = data.singleName)
            // data.avatarLink && (this.form1.imageUrl = data.avatarLink)&&(this.$store.state.user.headImg = data.avatarLink)&&( Cookies.set('headImg', data.avatarLink, { expires: 7 }))
            // data.provinceId && (this.cityArr = [Number(data.provinceId), Number(data.cityId)])
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    mounted() {
      // this.getCityData()
      // this.getUserInfo()
    }
  }
</script>

<style lang="scss" scoped>
.page-my-infomation {
  .wrap {
    width: 900px;
    margin: 0 auto;
    .title {
      padding: 0 30px;
      font-size: 20px;
      color: $primary;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .btn-edit {
        width: 140px;
        height: 32px;
        font-size: 16px;
        line-height: 32px;
      } 
    }
    .per-line {
      margin-top: 12px;
      width: 100%;
      height: 15px;
      // background: url(~@images/person-line.png) no-repeat center center;
      background-size: 100% 100%;
    }
    .form {
      width: 500px;
      margin: 0 auto;
      padding: 0 50px;
      color: #45443E;
    }
  }
}
</style>